/* cm-variant-image-filter.js
   Unsen/T4S SAFE + FIX: niente DOM move, niente bounce su variante 1.
   - Filtra per ALT "color:xxx"
   - Quando cambi variante: forza slider alla prima slide del colore
   - Evita che lo slider reimposti la variante (loop di ritorno)
*/

document.addEventListener('DOMContentLoaded', () => {
  /* ----------------------------
    CSS
  ---------------------------- */
  const style = document.createElement('style');
  style.textContent = `
    .cm-variant-hidden{
      display:none !important;
      visibility:hidden !important;
      opacity:0 !important;
      pointer-events:none !important;
    }
  `;
  document.head.appendChild(style);

  /* ----------------------------
    Utils base
  ---------------------------- */
  function getHandle() {
    const m = location.pathname.match(/\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  function getForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantIdInput() {
    return getForm()?.querySelector('[name="id"]') || null;
  }

  function getSelectedVariantId() {
    return getVariantIdInput()?.value || null;
  }

  async function fetchProductJSON() {
    const handle = getHandle();
    if (!handle) return null;
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return await res.json();
  }

  // ⚠️ option1 = colore. Se per te è option2, cambia qui.
  async function getColorFromProductJS(variantId) {
    const p = await fetchProductJSON();
    if (!p?.variants?.length) return null;
    const v = p.variants.find(x => String(x.id) === String(variantId));
    const color = (v?.option1 || '').toLowerCase().trim();
    return color || null;
  }

  function extractColorFromAlt(alt) {
    const a = (alt || '').toLowerCase();
    const m = a.match(/color:([a-z0-9_-]+)/);
    return m ? m[1] : null;
  }

  function getAltInside(el) {
    const img = el.querySelector?.('img, picture img');
    if (img) return img.getAttribute('alt') || '';
    const ns = el.querySelector?.('noscript');
    if (ns) {
      const tmp = document.createElement('div');
      tmp.innerHTML = ns.textContent || '';
      const nsImg = tmp.querySelector('img');
      return nsImg?.getAttribute('alt') || '';
    }
    return '';
  }

  function getScope() {
    return (
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.t4s-product') ||
      document.querySelector('main') ||
      document
    );
  }

  function getAllMediaItems(scope) {
    return [...scope.querySelectorAll('[data-media-id]')];
  }

  /* ----------------------------
    Flickity: trova istanza slider
  ---------------------------- */
  function getFlickityInstances(scope) {
    const sliders = [...scope.querySelectorAll('.flickityt4s-enabled')];
    const out = [];

    sliders.forEach(slider => {
      let inst = null;

      // jQuery data (più affidabile su Unsen)
      try {
        if (window.jQuery) {
          const $s = window.jQuery(slider);
          inst = $s.data('flickity') || $s.data('flickityt4s') || null;
        }
      } catch (e) {}

      // fallback: se Flickity è appeso al DOM (raramente)
      if (!inst && slider.flickityt4s) inst = slider.flickityt4s;
      if (!inst && slider.flickity) inst = slider.flickity;

      if (inst) out.push(inst);
    });

    return out;
  }

  function refreshFlickity(scope) {
    const insts = getFlickityInstances(scope);
    insts.forEach(inst => {
      try {
        if (typeof inst.reloadCells === 'function') inst.reloadCells();
        if (typeof inst.resize === 'function') inst.resize();
      } catch (e) {}
    });
    window.dispatchEvent(new Event('resize'));
  }

  /* ----------------------------
    FILTRO: nasconde solo, non sposta
  ---------------------------- */
  const scope = getScope();

  function applyColorFilter(color) {
    if (!color) return { shown: 0 };

    const items = getAllMediaItems(scope);
    let shown = 0;

    items.forEach(item => {
      const alt = getAltInside(item);
      const c = extractColorFromAlt(alt);

      // se non taggato, lascialo visibile
      if (!c) {
        item.classList.remove('cm-variant-hidden');
        return;
      }

      const show = (c === color);
      item.classList.toggle('cm-variant-hidden', !show);
      if (show) shown++;
    });

    // se per quel colore non c’è nulla, non distruggere tutto: mostra tutto
    if (shown === 0) {
      items.forEach(item => item.classList.remove('cm-variant-hidden'));
    }

    refreshFlickity(scope);
    return { shown };
  }

  /* ----------------------------
    FIX BOUNCE:
    quando cambio variante → porto lo slider alla prima immagine del colore
    e blocco temporaneamente “variant change by slide”
  ---------------------------- */
  let lastVid = null;
  let running = false;

  // blocco corto per evitare loop: slider -> variante -> slider -> ...
  let blockVariantWritesUntil = 0;

  function blockVariantWrites(ms = 600) {
    blockVariantWritesUntil = Date.now() + ms;
  }

  // Intercetta cambiamenti di variante “sospetti” subito dopo uno slide move
  // (se Unsen usa change sull’input id, qui possiamo difenderci)
  function maybeRevertVariantChangeIfBlocked() {
    if (Date.now() < blockVariantWritesUntil) {
      // mentre è bloccato, non facciamo partire run “di ritorno”
      return true;
    }
    return false;
  }

  function goToFirstVisibleSlide() {
    const insts = getFlickityInstances(scope);
    insts.forEach(inst => {
      try {
        // prova a trovare il primo cell visibile (non display:none)
        const cells = inst.cells || [];
        let targetIndex = 0;

        for (let i = 0; i < cells.length; i++) {
          const el = cells[i]?.element;
          if (!el) continue;
          const hidden = el.classList?.contains('cm-variant-hidden') || getComputedStyle(el).display === 'none';
          if (!hidden) { targetIndex = i; break; }
        }

        // seleziona senza “animazione” troppo aggressiva
        if (typeof inst.select === 'function') {
          inst.select(targetIndex, false, true);
        }
      } catch (e) {}
    });
  }

  async function run() {
    const vid = getSelectedVariantId();
    if (!vid) return;

    if (vid === lastVid) return;
    if (running) return;

    // se siamo nel blocco anti-loop, ignora questo cambio
    if (maybeRevertVariantChangeIfBlocked()) return;

    running = true;
    lastVid = vid;

    try {
      const color = await getColorFromProductJS(vid);

      // 1) blocca scritture variante causate dal “select” slider
      blockVariantWrites(200);

      // 2) applica filtro
      const r = applyColorFilter(color);

      // 3) se ci sono immagini, porta slider alla prima visibile
      if (r.shown > 0) {
        goToFirstVisibleSlide();
      }

    } catch (e) {
      console.warn('[variant-image-filter] errore:', e);
    } finally {
      running = false;
    }
  }

  // init
  requestAnimationFrame(run);

  // ascolta change/input/click sul form
  const form = getForm();
   if (form) {
    form.addEventListener('change', () => run(), true);
    form.addEventListener('input', () => run(), true);
    // NIENTE click: crea rimbalzi su Unsen
  }

  // polling più lento per evitare loop con la gallery
  setInterval(() => {
    const vid = getSelectedVariantId();
    if (vid && vid !== lastVid) run();
  }, 200);
});
